import PropTypes from 'prop-types';
import SiteHistory from './components/SiteHistory';
import ReimbursementDue from './components/ReimbursementDue';
import EnergyReimbursement from './components/EnergyReimbursement';

const FfBs = ({statement}) => {

  const reimbursementDue = statement.data.elecReimbursementDay + statement.data.elecReimbursementNight;

  return (
    <div>
      <SiteHistory siteLiveDate={statement.data.siteLiveDate} liveDaysInQ={statement.data.liveDaysInQ}/>
      <EnergyReimbursement data={statement.data}/>
      <ReimbursementDue reimbursementDue={reimbursementDue}/>
    </div>
  )
}

export default FfBs;

FfBs.propTypes = {
  statement: PropTypes.object.isRequired,
};